import { ID_BACK_IN_STOCK_CONTAINER } from './constants';
import { initEventChangeVariantUrl } from './events/variant-events';
import { fetchProductData, initialVariant } from './product/product-data';
import { checkIfVariantOutOfStock, checkIfVariantPreOrder } from './product/variant-utils';
import { initSettingsProvider } from './settings';
import { renderBackInStockTemplate } from './template/renderer';
import { updateBackInStockDisplay } from './ui/display';
import { resetDefaultOptionDropdown } from './ui/variant-dropdown';

/**
 * @type {import('./index.d').integrateBackInStockFeature}
 */
export async function integrateBackInStockFeature(context) {
  const productId = window.boostSDData?.product?.id;
  const product = productId ? await fetchProductData(context, productId) : null;

  const moduleContext = {
    settings: await initSettingsProvider(context),
    product,
  };

  context.render(async () => {
    const bisBlock = document.querySelector(`#${ID_BACK_IN_STOCK_CONTAINER}`);
    if (!bisBlock) {
      console.warn('[Back-In-Stock] - Warning: Container not found');
      return;
    }

    const { showOnPreOrderProduct, showOnVariantOutOfStock } =
      moduleContext.settings.productSettings();

    if (!product || !product.variants) {
      console.error('Product or variants data is missing:', product, product?.variant);
      return;
    }

    const variants = product.variants;
    const allUnavailable = variants?.every((variant) => !variant.available);

    const [getVariant] = context.useContextState('bis-variant', {});
    const selectedVariant = getVariant();
    const selectedVariantId = selectedVariant.id;

    const variant = selectedVariantId
      ? variants.find((variant) => variant.id === selectedVariantId)
      : null;

    const isProductOutOfStock = checkIfVariantOutOfStock(product);
    const isProductPreOrder = checkIfVariantPreOrder(product);

    const shouldDisplayBisBlock = () => {
      if (allUnavailable) return true;

      if (variant?.available) {
        if (
          !variant.preorder &&
          showOnVariantOutOfStock.show &&
          (isProductOutOfStock ||
            (isProductPreOrder && !isProductOutOfStock && showOnPreOrderProduct.show))
        ) {
          return true;
        }

        if (variant.preorder && showOnPreOrderProduct.show) {
          if (
            (isProductOutOfStock && showOnVariantOutOfStock.show) ||
            (variant.inventory_quantity > 0 && showOnVariantOutOfStock.show) ||
            variant.inventory_quantity <= 0
          ) {
            return true;
          }
        }
      } else {
        return true;
      }

      return false;
    };

    bisBlock.style.display = shouldDisplayBisBlock() ? 'block' : 'none';

    resetDefaultOptionDropdown(selectedVariant);
  }, ['bis-variant']);

  if (!product || !product.variants) {
    console.error('Product or variants data is missing:', product, product?.variant);
    return;
  }

  const firstVariant = await initialVariant(context);
  const [, setVariant] = context.useContextState('bis-variant', {});
  setVariant(firstVariant);

  const { showNotifyButton } = await updateBackInStockDisplay(moduleContext, product);

  if (showNotifyButton) {
    initEventChangeVariantUrl(context);
    await renderBackInStockTemplate(context, moduleContext, product);
  }
}
